// extracted by mini-css-extract-plugin
export default {"wrapper":"visibility-setting_wrapper__tqIt5"};